export const GET_API_DATA = 'containers/HomePage/GET_API_DATA';
export const GET_API_DATA_LOADED = 'containers/HomePage/GET_API_DATA_LOADED';
export const GET_API_DATA_ERROR = 'containers/HomePage/GET_API_DATA_ERROR';
